module.exports = __webpack_public_path__ + "html/sidesheet.component.html";